import DateFnsUtils from '@date-io/date-fns';
import {
  Card,
  Button,
  CardContent,
  CardHeader,
  createMuiTheme,
  DialogActions,
  Divider,
  Grid,
  TextField,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  MenuItem,
  Snackbar,
  Backdrop,
  CircularProgress, Stepper, Step, StepLabel, Dialog, DialogTitle, DialogContent
} from '@material-ui/core';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import { makeStyles, ThemeProvider } from '@material-ui/styles';
import clsx from 'clsx';
import 'date-fns';
import trLocale from 'date-fns/locale/tr';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import MaskedInput from 'react-text-mask';
import axios from 'src/utils/axios';
import DeleteIcon from '@material-ui/icons/Delete';
import SaveIcon from '@material-ui/icons/Save';
import Alert from 'src/components/Alert';
import { getUser } from 'src/utils/Common';
import { setTask } from '../../store/actions/taskActions';
import ProductSearch from '../../components/Selects/ProductSearch';
import MaterialSearch from '../../components/Selects/MaterialSearch';
import Page from 'src/components/Page';
import { Grade } from '@material-ui/icons';
import SearchIcon from "@material-ui/icons/Search";
import RetailerSoldToShipToSearch from "../../components/Retailer/RetailerSoldToShipToSearch";

const useStyles = makeStyles(theme => ({
  root: {},
  dividerDegisim: {
    backgroundColor: '#1D3343'
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  fieldsComboDegisim: {
    margin: theme.spacing(0),
    display: 'flex'
  }
}));
const Degisimsiyah = '#424242';
const materialTheme = createMuiTheme({
  palette: {
    primary: {
      contrastText: '#FFFFFF',
      dark: Degisimsiyah,
      main: Degisimsiyah,
      light: Degisimsiyah
    }
  }
});
const localeMap = {
  tr: trLocale
};
function TextMaskCustom(props) {
  const { inputRef, ...other } = props;
  return (
    <MaskedInput
      {...other}
      ref={ref => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[
        'T',
        'R',
        /\d/,
        /\d/,
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        ' ',
        /\d/,
        /\d/
      ]}
      placeholderChar={'\u2000'}
      guide={false}
      showMask
    />
  );
}
function ProductChange({ className, ReceiptNo, readonly, tasks, setTask, ProductChangePopup }) {
  const locale = localStorage.getItem('i18nextLng');
  const classes = useStyles();
  const { t } = useTranslation('work_order');
  const [ChangeData, setChangeData] = useState({});
  const [ChangeReasonDetailData, setChangeReasonDetailData] = useState([]);
  const [UnavailableMaterial, setUnavailableMaterial] = useState([]);
  const [ChangeReasonData, setChangeReasonData] = useState([]);
  const [ChangeExchangeTypeExtendData, setChangeExchangeTypeExtendData] = useState([]);
  const [ChangeExchangeTypeExtend, setChangeExchangeTypeExtend] = useState([]);
  const [ChangeStatusData, setChangeStatusData] = useState([]);
  const [ChangePdi, setChangePdi] = useState('');
  const [ChangeItemNo, setChangeItemNo] = useState('');
  const [ChangeSalesItemNo, setChangeSalesItemNo] = useState('');
  const [ChangeInvoicePrice, setChangeInvoicePrice] = useState('');
  const [ChangeInvoiceDate, setChangeInvoiceDate] = useState('');
  const [ChangeSalesDocDate, setChangeSalesDocDate] = useState(null);
  const [ChangeInvoiceNr, setChangeInvoiceNr] = useState('');
  const [EDFR, setEDFR] = useState('');
  const [ChangeSalesNr, setChangeSalesNr] = useState('');
  const [ChangeDataMaterial, setChangeDataMaterial] = useState({});
  const [ChangeReasonDetail, setChangeReasonDetail] = useState('');
  const [ChangeBankCode, setChangeBankCode] = useState('');
  const [ChangeBankName, setChangeBankName] = useState('');
  const [ChangeSoldTo, setChangeSoldTo] = useState('');
  const [ChangeShipTo, setChangeShipTo] = useState('');
  const [ChangeType, setChangeType] = useState(0);
  const [ChangeTaxId, setChangeTaxId] = useState('');
  const [ChangeIdNumber, setChangeIdNumber] = useState('');
  const [ChangeTaxOffice, setChangeTaxOffice] = useState('');
  const [ChangeReason, setChangeReason] = useState(0);
  const [ChangeSparePart, setChangeSparePart] = useState(0);
  const [ChangeGrade, setChangeGrade] = useState(0);
  const [ChangeServiceNote, setChangeServiceNote] = useState('');
  const [ExchangeMaterialOrderNr, setExchangeMaterialOrderNr] = useState('');
  const [ChangeReceived, setChangeReceived] = useState(0);
  const [OperationSource, setOperationSource] = useState(0);
  const [Upgrade, setUpgrade] = useState(0);
  const [ChangeStatus, setChangeStatus] = useState(0);
  const [ChangeIban, setChangeIban] = useState('');
  const [uyari, setUyari] = React.useState(false);
  const [uyariTip, setUyariTip] = React.useState();
  const [loading, setLoading] = useState(false);
  const [requiredForMaterial, setRequiredForMaterial] = React.useState(false);
  const SessionUser = getUser();
  const [activeStep, setActiveStep] = React.useState(0);
  const [UpgradeData, setUpgradeData] = React.useState([{ Id: 1, Dsc: t('lblYes') }, { Id: 2, Dsc: t('lblNo') }]);

  const [RetailerSoldToShipToPopUp, setRetailerSoldToShipToPopUp] = useState(false);


  const steps = getSteps();
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: t('success_message')
  });
  const ChangeMainData = tasks.tasks.filter(
    d => parseInt(d.ReceiptNo) === parseInt(ReceiptNo)
  );
  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  function formatNumberForDisplayInvoice(input) {
    const cleanedInput = input.replace(/[^0-9.]/g, '');
    const parts = cleanedInput.split('.');
    let formattedNumber = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    if (parts.length > 1) {
      formattedNumber += '.' + parts[1].substr(0, 2);
    }

    return formattedNumber;
  }

  function formatNumberForDisplay(input, beforePoint = 3, afterPoint = 2, onlyPositive = true) {
    let cleanedInput = input.replace(/[^0-9.-]/g, '');

    if (cleanedInput.indexOf('-') > 0) {
      cleanedInput = cleanedInput.replace(/-/g, '');
    }
    if (onlyPositive) {
      cleanedInput = cleanedInput.replace(/-/g, '');
    }

    const parts = cleanedInput.split('.');

    const wholePart = parts[0];
    const limitedWholePart = wholePart.slice(0, beforePoint); 

    let fractionalPart = parts.length > 1 ? parts[1].substr(0, afterPoint) : '';

    let formattedNumber = limitedWholePart;
    if (fractionalPart) {
      formattedNumber += '.' + fractionalPart;
    }

    return cleanedInput.startsWith('-') && !onlyPositive ? '-' + formattedNumber : formattedNumber;
  }




  const GetChangeReason = () => {
    axios
      .get(`/GetChangeReason`)
      .then(response => {
        if (response.data.length > 0) {
          setChangeReasonData(response.data);
          setChangeReason(ChangeMainData[0].ChangeReason || '0');
        }
      })
      .catch(error => { });
  };

  const GetExchangeTypeExtendList = () => {
    axios
      .get(`/GetExchangeTypeExtendList`)
      .then(response => {
        if (response.data.length > 0) {
          setChangeExchangeTypeExtendData(response.data);
          setChangeExchangeTypeExtend(ChangeExchangeTypeExtendData[0].Id || '0');
        }
      })
      .catch(error => { });
  };

  useEffect(() => {
    GetChangeReason();
    GetExchangeTypeExtendList();
    if (ChangeMainData[0].ChangeReason > 0) {
      axios
        .get(`/GetChangeReasonDetailWithValue/${ChangeMainData[0].ChangeReason}`)
        .then(response => {
          if (response.data.length > 0) {
            setChangeReasonDetailData(response.data);
            setChangeReasonDetail(ChangeMainData[0].ChangeReasonDetail || '0');
          }
        })
        .catch(error => { });
    }
    
    setChangeExchangeTypeExtend(ChangeMainData[0].ChangeExchangeTypeExtend || '0');
    setChangePdi(ChangeMainData[0].ChangePdi || '0');
    setChangeItemNo(ChangeMainData[0].ChangeItemNo || '0'); 
    setChangeSalesItemNo(ChangeMainData[0].ChangeSalesItemNo || '0');
    setChangeData(ChangeMainData[0]);
    setChangeInvoiceDate(ChangeMainData[0].WarrantyDate || '');
    setChangeSalesDocDate(ChangeMainData[0].ChangeSalesDocDate || null);
    setChangeInvoicePrice(ChangeMainData[0].ChangeInvoicePrice || 0);
    setChangeInvoiceNr(ChangeMainData[0].ChangeInvoiceNr || '0');
    setEDFR(ChangeMainData[0].EDFR || '');
    setChangeSalesNr(ChangeMainData[0].ChangeSalesNr || '');
    setChangeIban(ChangeMainData[0].ChangeIban || '');
    setChangeBankCode(ChangeMainData[0].BankCode || '');
    setChangeDataMaterial(ChangeMainData[0]);
    setChangeBankName(ChangeMainData[0].ChangeBankName || '');
    setChangeBankCode(ChangeMainData[0].ChangeBankCode || '');
    setChangeSoldTo(ChangeMainData[0].ChangeSoldTo || '');
    setChangeShipTo(ChangeMainData[0].ChangeShipTo || '');
    setChangeServiceNote(ChangeMainData[0].ChangeServiceNote || '');
    setExchangeMaterialOrderNr(ChangeMainData[0].ExchangeMaterialOrderNr || '');
    setChangeType(ChangeMainData[0].ChangeType || 0);
    setChangeTaxOffice(ChangeMainData[0].ChangeTaxOffice || '');
    setChangeTaxId(ChangeMainData[0].ChangeTaxId || '');
    setChangeIdNumber(ChangeMainData[0].ChangeIdNumber || '');
    setChangeReceived(ChangeMainData[0].ChangeReceived || 0);
    setOperationSource(ChangeMainData[0].OperationSource || 0);
    setUpgrade(ChangeMainData[0].Upgrade || 0);
    setChangeGrade(ChangeMainData[0].ChangeGrade || 0);
    setChangeSparePart(ChangeMainData[0].ChangeSparePart || 0);
    setUnavailableMaterial(ChangeMainData[0].ChangeUnavailableMaterial || []);
    // eslint-disable-next-line
  }, [ChangeMainData[0].ReceiptNo]);

  const handleChangeReasonDetail = e => {
    setChangeReasonDetail(e.target.value || 0);
    let job = ChangeMainData[0];
    job = {
      ...job,
      ChangeReasonDetail: e.target.value || 0
    };
    setTask(job);
  };
  const handleChangeSparePart = e => {

    let job = ChangeMainData[0];
    job = {
      ...job,
      ChangeSparePart: e.target.value || 0
    };
    setTask(job);
  };
  const handleChangeInvoicePrice = e => {
    const formattedValue = formatNumberForDisplayInvoice(e.target.value) || "0";
    setChangeInvoicePrice(formattedValue || 0);
    let job = ChangeMainData[0];
    job = {
      ...job,
      ChangeInvoicePrice: formattedValue || 0
    };
    setTask(job);
  };
  const handleChangeInvoiceDate = e => {
    const Deger = moment(e).format('YYYY-MM-DD');
    let job = ChangeMainData[0];
    job = {
      ...job,
      ChangeInvoiceDate: Deger
    };
    setTask(job);
    setChangeInvoiceDate(Deger);
  };
  
  const handleChangeSalesDocDate = e => {
    const docDate = moment(e).format('YYYY-MM-DD');
    let job = ChangeMainData[0];
    job = {
      ...job,
      ChangeSalesDocDate: docDate
    };
    setTask(job);
    setChangeSalesDocDate(docDate);
  };

  const handleBlurChangeInvoiceNr = () => {
    setChangeInvoiceNr(formatLimit(ChangeInvoiceNr, 10));
  };
  
  const handleChangeInvoiceNr = e => {
    let job = ChangeMainData[0];
    let targetValue = e.target.value || '';
    if(SessionUser.TenantId === 79) {
      const formattedValue = formatNumberForDisplay(e.target.value, 10 , 0, true) || "";
      setChangeInvoiceNr(formattedValue);  
      targetValue = formattedValue;
    }
    else {
      setChangeInvoiceNr(targetValue);
    }

    job = {
      ...job,
      ChangeInvoiceNr: targetValue
    };
    setTask(job);
    
  };

  const handleEDFR = e => {
    setEDFR(e.target.value || '');
    let job = ChangeMainData[0];
    job = {
      ...job,
      EDFR: e.target.value || ''
    };
    setTask(job);
  };

  const handleBlurChangeSalesNr = () => {
    setChangeSalesNr(formatLimit(ChangeSalesNr, 10));
  };

  
  const handleChangeSalesNr = e => {
    let job = ChangeMainData[0];
    let targetValue = e.target.value || '';
    if(SessionUser.TenantId === 79) {
      const formattedValue = formatNumberForDisplay(e.target.value, 10 , 0, true) || "";
      setChangeSalesNr(formattedValue);
      targetValue = formattedValue;
    }
    else {
      setChangeSalesNr(targetValue);
    }

    job = {
      ...job,
      ChangeSalesNr: targetValue || ''
    };
    setTask(job);
  };
  const handleChangeIban = e => {
    setChangeIban(e.target.value || '');
    let job = ChangeMainData[0];
    job = {
      ...job,
      ChangeIban: e.target.value || ''
    };
    setTask(job);
  };
  const handleChangeBankCode = e => {
    setChangeBankCode(e.target.value || '');
    let job = ChangeMainData[0];
    job = {
      ...job,
      ChangeBankCode: e.target.value || ''
    };
    setTask(job);
  };
  const handleChangeBankName = e => {
    setChangeBankName(e.target.value || '');
    let job = ChangeMainData[0];
    job = {
      ...job,
      ChangeBankName: e.target.value || ''
    };
    setTask(job);
  };

  const handleClickService = (obj,row) => {
    setChangeSoldTo(obj.MainRetailerDesc || '');
    setChangeShipTo(row.Dsc || '');
    let job = ChangeMainData[0];
    job = {
      ...job,
      ChangeSoldTo: obj.MainRetailerDesc || '',
      ChangeShipTo: row.Dsc || ''
    };

    setTask(job);
    setRetailerSoldToShipToPopUp(false);
  };

  const handleChangeIdNumber = e => {
    setChangeIdNumber(e.target.value || 0);
    let job = ChangeMainData[0];
    job = {
      ...job,
      ChangeIdNumber: e.target.value || 0
    };
    setTask(job);
  };
  const handleChangeTaxId = e => {
    setChangeTaxId(e.target.value || '');
    let job = ChangeMainData[0];
    job = {
      ...job,
      ChangeTaxId: e.target.value || ''
    };
    setTask(job);
  };
  const handleChangeChangeTaxOffice = e => {
    setChangeTaxOffice(e.target.value || '');
    let job = ChangeMainData[0];
    job = {
      ...job,
      ChangeTaxOffice: e.target.value || ''
    };
    setTask(job);
  };

  const handleChangeExtendType = e => {
    //serdar
    var ValueControl = e.target.value || 0;
    const menuItemData = ChangeExchangeTypeExtendData.find(item => item.Id === ValueControl);

    if (parseInt(menuItemData.FK_ExchangeTypeId) === 1) {
      setUpgradeData([{ Id: 1, Dsc: t('lblYes') }, { Id: 2, Dsc: t('lblNo') }]);
    } else {
      setUpgradeData([{ Id: 2, Dsc: t('lblNo') }]);
    }

    setChangeType(menuItemData.FK_ExchangeTypeId)
    setChangeGrade(menuItemData.FK_GradeTypeId)
    setChangeExchangeTypeExtend(ValueControl);
    let job = ChangeMainData[0];
    job = {
      ...job,
      ChangeType: e.target.value || 0
    };
    setTask(job);
  };

  const handleChangePdi = e => {
    
    const formattedValue = formatNumberForDisplay(e.target.value, 3 , 2, true) || "";

    setChangePdi(formattedValue);
    let job = ChangeMainData[0];
    job = {
      ...job,
      ChangeInvoicePrice: formattedValue
    };
    setTask(job);
  };


  const handleBlurChangeItemNo = () => {
    setChangeItemNo(formatLimit(ChangeItemNo, 6));
  };

  const handleBlurChangeSalesItemNo = () => {
    setChangeSalesItemNo(formatLimit(ChangeSalesItemNo, 6));
  };

  const formatLimit = (value, characterLimit) => {
    return value.toString().padStart(characterLimit, '0');
  };

  const handleChangeItemNo = e => {    
    const formattedValue = formatNumberForDisplay(e.target.value, 6 , 0, true) || "";
    setChangeItemNo(formattedValue);
    let job = ChangeMainData[0];
    job = {
      ...job,
      ChangeItemNo: formattedValue
    };
    setTask(job);
  };

  const handleChangeSalesItemNo = e => {
    const formattedValue =
      formatNumberForDisplay(e.target.value, 6, 0, true) || '';
    setChangeSalesItemNo(formattedValue);
    let job = ChangeMainData[0];
    job = {
      ...job,
      ChangeSalesItemNo: formattedValue
    };
    setTask(job);
  };

  const handleChangeType = e => {
    //serdar
    var ValueControl = e.target.value || 0;

    if (parseInt(ValueControl) === 1) {
      setUpgradeData([{ Id: 1, Dsc: t('lblYes') }, { Id: 2, Dsc: t('lblNo') }]);
    } else {
      setUpgradeData([{ Id: 2, Dsc: t('lblNo') }]);
    }

    setChangeType(e.target.value || 0);
    let job = ChangeMainData[0];
    job = {
      ...job,
      ChangeType: e.target.value || 0
    };
    setTask(job);
  };
  const handleChangeReason = e => {
    axios
      .get(`/GetChangeReasonDetailWithValue/${e.target.value}`)
      .then(response => {
        if (response.data.length > 0) {
          setChangeReasonDetailData(response.data);          
          setChangeReasonDetail(response.data[0].Id);
        } else {
          var changeReasonDetailName = ChangeReasonData.find(x => x.Id == e.target.value).YourLanguageDescription;
          var reasonDetailEmptyList = [{ Id: 0, Text: changeReasonDetailName }];
          setChangeReasonDetailData(reasonDetailEmptyList);
          setChangeReasonDetail(0);
        }
      })
      .catch(error => { });
    let job = ChangeMainData[0];
    job = {
      ...job,
      ChangeReason: e.target.value || ''
    };

    setChangeSparePart(ChangeReasonData.filter(i => i.Id == e.target.value)[0].SparePart)
    setTask(job);
    setChangeReason(e.target.value);
  };


  useEffect(() => {
    if (ChangeReason && !ChangeSparePart && ChangeReasonData) {
      setChangeSparePart(ChangeReasonData.filter(i => i.Id == ChangeReason)[0]?.SparePart)
    }
  }, [ChangeReason])


  const handleChangeGrade = e => {
    setChangeGrade(e.target.value || 0);
    let job = ChangeMainData[0];
    job = {
      ...job,
      ChangeGrade: e.target.value || 0
    };
    setTask(job);
  };

  const handleExchangeMaterialOrderNr = e => {
    setExchangeMaterialOrderNr(e.target.value || '');
    let job = ChangeMainData[0];
    job = {
      ...job,
      ExchangeMaterialOrderNr: e.target.value || ''
    };
    setTask(job);
  };

  const handleChangeServiceNote = e => {
    setChangeServiceNote(e.target.value || '');
    let job = ChangeMainData[0];
    job = {
      ...job,
      ChangeServiceNote: e.target.value || ''
    };
    setTask(job);
  };
  const handleChangeReceived = e => {
    setChangeReceived(e.target.value || 0);
    let job = ChangeMainData[0];
    job = {
      ...job,
      ChangeReceived: e.target.value || 0
    };
    setTask(job);
  };

  const handleUpgrade = e => {
    setUpgrade(e.target.value || 0);
    let job = ChangeMainData[0];
    job = {
      ...job,
      Upgrade: e.target.value || 0
    };
    setTask(job);
  };
  const handleOperationSource = e => {
    setOperationSource(e.target.value || 0);
    let job = ChangeMainData[0];
    job = {
      ...job,
      OperationSource: e.target.value || 0
    };
    setTask(job);
  };

  const setChangeModel = param => {
    let job = ChangeMainData[0];
    job = {
      ...job,
      ChangeProductId: param.ProductId || 0,
      ChangeProduct: param.ACIKLAMA || '',
      ChangeProductCode: param.KUL_MODEL_KODU || ''
    };
    setTask(job);
    setChangeData(job);
  };
  const setChangeMaterial = param => {
    const selectedChangeMaterialData = UnavailableMaterial;
    selectedChangeMaterialData.push({
      MaterialCode: param.MaterialCode || '',
      Material: param.Material || ''
    });

    setUnavailableMaterial(selectedChangeMaterialData);

    let job = ChangeMainData[0];
    job = {
      ...job,
      ChangeMaterialCode: param.MaterialCode || '',
      ChangeMaterial: param.Material || '',
      ChangeUnavailableMaterial: selectedChangeMaterialData
    };
    setTask(job);
    setChangeDataMaterial(job);
  };

  const DeleteUnavailableMaterial = (event, MaterialCode) => {
    const selectedChangeMaterialData = UnavailableMaterial;
    const filteredIndex = selectedChangeMaterialData.findIndex(
      x => x.MaterialCode === MaterialCode
    );
    selectedChangeMaterialData.splice(filteredIndex, 1);

    setUnavailableMaterial(selectedChangeMaterialData);

    let job = ChangeMainData[0];
    job = {
      ...job,
      ChangeUnavailableMaterial: selectedChangeMaterialData
    };
    setTask(job);
    setChangeDataMaterial(job);
  };

  function formatToDecimal(input) {
    const cleanedInput = input.toString().replace(/[,]/g, '');
    const decimalValue = parseFloat(cleanedInput);

    return decimalValue.toFixed(2);
  }

  const SaveExChange = () => {
    setRequiredForMaterial(true);
    if (ChangeSparePart === 1 && UnavailableMaterial.length === 0) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('lblMustFieldControl')
      });
      setUyariTip('error');
      setUyari(true);
      setLoading(false);
      return;
    }
    setRequired(true);
    //For Russia (TenantId 118) - Invoice fields are not required
    const invoiceValidation = SessionUser.IsIhpTenant ? true : ChangeInvoiceNr !== 0;
    if (
      OperationSource === 0 ||
      Upgrade === 0 ||
      ChangeReceived === 0 ||
      ChangeType === 0 ||
      ChangeGrade === 0 ||
      !invoiceValidation
    ) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('lblMustFieldControl')
      });
      setUyariTip('error');
      setUyari(true);
      setLoading(false);
      return;
    }
    //USA
    if(SessionUser.TenantId === 79 && ChangeType !== 2 && (ChangeSalesItemNo === '' || ChangeSalesNr === ''))
    {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('lblMustFieldControl')
      });
      setUyariTip('error');
      setUyari(true);
      setLoading(false);
      return;
    }
    setLoading(true);

    const extractFirstSegment = (value) => {
      if (!value) return null; // Return null if value is null or empty
      const match = value.match(/^[^-]+/); // Match everything up to the first '-'
      return match ? match[0] : null; // Return the first segment or null if not found
    };

    const dataBody = {
      WorkOrderId: parseInt(ReceiptNo),
      EmployeeId: SessionUser.TechnicianId,
      ChangeExchangeTypeExtend,
      ChangeTaxOffice,
      ChangeTaxId,
      ChangeIdNumber,
      ChangeType,
      ChangeGrade,
      ChangeReason,
      ChangeReasonDetail,
      ChangeReceived,
      OperationSource,
      Upgrade,
      ChangeStatus,
      ChangeServiceNote,
      ChangeBankName,
      ChangeBankCode,
      ChangeIban,
      ChangeInvoiceNr,
      EDFR: SessionUser.TenantId === 75 ? EDFR : '',
      ChangeInvoicePrice: formatToDecimal(ChangeInvoicePrice),
      ChangeInvoiceDate,
      ChangeProductId: ChangeData.ChangeProductId,
      ChangeUnavailableMaterialParam: ChangeSparePart === 1 ? UnavailableMaterial : [],
      ChangeSoldTo: extractFirstSegment(ChangeSoldTo),
      ChangeShipTo: extractFirstSegment(ChangeShipTo),
      ChangePdi,
      ChangeItemNo,
      ChangeSparePart,
      SAP_Type: false,
      CreateUserId: SessionUser.TechnicianId,
      ExchangeMaterialOrderNr,
      ChangeSalesNr,
      ChangeSalesDocDate,
      ChangeSalesItemNo
    };

    const dataConfig = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/SetExChange', dataBody, dataConfig)
      .then(response => {
        const res = response.data.length === 0 ? [] : response.data;
        if (res[0].ErrorCode === 0) {
          setresponseMessage({
            ErrorCode: 10,
            ErrorDescription: t('success_message')
          });
          setUyariTip('success');
          setUyari(true);
          setLoading(false);
          axios
            .get(`/GetUnavailableMaterial/${ReceiptNo}`).then((response) => {
              if (response.data !== "") {
                setUnavailableMaterial(response.data);
              } else {
                setUnavailableMaterial([]);
              }

              ChangeMainData[0].ChangeUnavailableMaterial = response.data
            })
        } else {
          setresponseMessage({
            ErrorCode: 10,
            ErrorDescription: res[0].ErrorDescription
          });
          setUyariTip('error');
          setUyari(true);
          setLoading(false);
        }
      })
      .catch(error => {
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription: t('lblError')
        });
        setUyariTip('error');
        setUyari(true);
        setLoading(false);
      });
  };

  function getSteps() {
    if (SessionUser.TenantId === 87 || SessionUser.TenantId === 16) {
      //For Ireland and UK
      return [
        t('lblDefineTheProblem'),
        t('lblSelectProductConditions'),
        t('lblFillInvoiceDetails'),
        t('lblSummary')
      ];
    } else if (SessionUser.IsIhpTenant) {
      //For Russia - Hide Fill Invoice Details step
      return [
        t('lblDefineTheProblem'),
        t('lblSelectCustomerPreferrence'),
        t('lblSelectProductConditions'),
        t('lblSummary')
      ];
    } else {
      return [
        t('lblDefineTheProblem'),
        t('lblSelectCustomerPreferrence'),
        t('lblSelectProductConditions'),
        t('lblFillInvoiceDetails'),
        t('lblSummary')
      ];
    }
  }

  const handleNext = () => {
    setRequired(true);
    setRequiredForMaterial(true);
    if (SessionUser.TenantId === 87 || SessionUser.TenantId === 16) {
      setUpgrade(2); //No
      setChangeType(1); //Exchange
      if (activeStep === 3) {
        SaveExChange();
      }
    } else if (SessionUser.IsIhpTenant) {
      //For Russia - 4 steps (0,1,2,3) - Summary is step 3
      if (activeStep === 3) {
        SaveExChange();
      }
    } else {
      if (activeStep === 4) {
        SaveExChange();
      }
    }
    if (ChangeReason === 0 || ChangeServiceNote === '' || ChangeReasonDetail === '' ||
      (ChangeSparePart === 1 && UnavailableMaterial.length === 0) ||
      (Upgrade === 1 && ChangeData.ChangeProductId === 0)
    ) {
      setActiveStep((prevActiveStep) => prevActiveStep);
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const [
    required,
    setRequired
  ] = React.useState(false);


  function getStepContent(stepIndex) {
    if (SessionUser.TenantId === 87 || SessionUser.TenantId === 16) {
      switch (stepIndex) {
        case 0:
          return (
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} lg={12}>
                <TextField
                  size="small"
                  fullWidth
                  select
                  label={t('Degisim_Nedeni')}
                  value={ChangeReason}
                  error={ChangeReason > 0 ? false : required}
                  onChange={handleChangeReason}
                  labelId="degisimNeden_label"
                  variant="outlined"
                >
                  {ChangeReasonData.map(p => {
                    return (
                      <MenuItem key={p.Id} value={p.Id}>
                        {p.MainLanguageDescription}
                      </MenuItem>
                    );
                  })}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={12} lg={12}>
                <TextField
                  size="small"
                  fullWidth
                  select
                  label={t('Degisim_Nedeni_Detay')}
                  error={ChangeReasonDetail === '' ? required : false}
                  value={ChangeReasonDetail}
                  onChange={handleChangeReasonDetail}
                  labelId="degisimNedenDetay_label"
                  variant="outlined"
                >
                  {ChangeReasonDetailData.map(p => {
                    return (
                      <MenuItem key={p.Id} value={p.Id}>
                        {p.Text}
                      </MenuItem>
                    );
                  })}
                </TextField>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                lg={12}
                style={{
                  display:
                    ChangeSparePart === 1 || ChangeDataMaterial.length > 0
                      ? 'inline'
                      : 'none'
                }}
              >
                <MaterialSearch
                  setMalzeme={setChangeMaterial}
                  setProduct={ChangeMainData[0].ModelCode}
                  value={
                    {
                      MALZEME_STOK_NO: ChangeDataMaterial.ChangeMaterialCode,
                      ACIKLAMA: ChangeDataMaterial.ChangeMaterial
                    } || ''
                  }
                  searchParam=""
                  error={
                    ChangeSparePart === 1 && UnavailableMaterial.length === 0
                      ? requiredForMaterial
                      : false
                  }
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                lg={12}
                style={{ display: ChangeSparePart === 1 ? 'inline' : 'none' }}
              >
                <TextField
                  label={t('lblMaterialOrderId')}
                  name="ExchangeMaterialOrderNr"
                  fullWidth
                  size="small"
                  value={ExchangeMaterialOrderNr}
                  onChange={handleExchangeMaterialOrderNr}
                  variant="outlined"
                />
                <List>
                  {UnavailableMaterial.map(item => (
                    <ListItem key={item.MaterialCode}>
                      <ListItemText
                        primary={item.Material}
                        secondary={item.MaterialCode}
                      />
                      <ListItemSecondaryAction>
                        <IconButton
                          edge="end"
                          style={{ color: 'red' }}
                          onClick={event =>
                            DeleteUnavailableMaterial(event, item.MaterialCode)
                          }
                          aria-label="delete"
                        >
                          <DeleteIcon />
                        </IconButton>
                      </ListItemSecondaryAction>
                    </ListItem>
                  ))}
                </List>
              </Grid>
              <Grid item xs={12} sm={12} lg={12}>
                <TextField
                  label={t('Servis_Notu')}
                  name="DegisimServisNot"
                  multiline
                  rows={3}
                  fullWidth
                  error={ChangeServiceNote === '' ? required : false}
                  value={ChangeServiceNote}
                  onChange={handleChangeServiceNote}
                  variant="outlined"
                  disabled={readonly}
                />
              </Grid>
              <Grid item xs={12} sm={12} lg={12}>
                <br />
                <br />
              </Grid>
            </Grid>
          );
        case 1:
          return (
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} lg={12}>
                <TextField
                  size="small"
                  fullWidth
                  select
                  error={ChangeGrade === 0 ? required : false}
                  label={t('lblGrade')}
                  value={ChangeGrade}
                  onChange={handleChangeGrade}
                  labelId="Grade_label"
                  variant="outlined"
                >
                  <MenuItem key={1} value={1}>
                    {t('lblFunctional')}
                  </MenuItem>
                  <MenuItem key={2} value={2}>
                    {t('lblRefurbishable')}
                  </MenuItem>
                  <MenuItem key={3} value={3}>
                    {t('lblScrap')}
                  </MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} sm={12} lg={12}>
                <TextField
                  size="small"
                  fullWidth
                  select
                  label={t('lblOperationSource')}
                  value={OperationSource}
                  error={OperationSource === 0 ? required : false}
                  onChange={handleOperationSource}
                  labelId="lblOperationSourceLabel"
                  variant="outlined"
                >
                  <MenuItem key={1} value={1}>
                    {t('lblServiceShop')}
                  </MenuItem>
                  <MenuItem key={2} value={2}>
                    {t('lblDealer')}
                  </MenuItem>
                  <MenuItem key={3} value={3}>
                    {t('lblLogistics')}
                  </MenuItem>
                  <MenuItem key={4} value={4}>
                    {t('lblCallCenter')}
                  </MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} sm={12} lg={12}>
                <TextField
                  size="small"
                  fullWidth
                  select
                  label={t('lblProductLocation')}
                  value={ChangeReceived}
                  error={ChangeReceived === 0 ? required : false}
                  onChange={handleChangeReceived}
                  labelId="teslimalindi_label"
                  variant="outlined"
                >
                  <MenuItem key={2} value={2}>
                    {t('lblCustomer')}
                  </MenuItem>
                  <MenuItem key={1} value={1}>
                    {t('lblServiceShop')}
                  </MenuItem>
                  <MenuItem key={3} value={3}>
                    {t('lblDealer')}
                  </MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} sm={12} lg={12}>
                <br />
                <br />
              </Grid>
            </Grid>
          );
        case 2:
          return ChangeType === 2 ? (
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} lg={6}>
                <TextField
                  label={t('Fatura_No')}
                  name="FaturaNo"
                  multiline
                  fullWidth
                  size="small"
                  error={
                    (ChangeType === 2) & (ChangeInvoiceNr === '')
                      ? required
                      : false
                  }
                  value={ChangeInvoiceNr}
                  onChange={handleChangeInvoiceNr}
                  variant="outlined"
                  disabled={readonly}
                />
              </Grid>
              <Grid item xs={12} sm={12} lg={6}>
                <ThemeProvider theme={materialTheme}>
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    locale={localeMap[locale]}
                  >
                    <KeyboardDatePicker
                      margin="normal"
                      color="white"
                      inputVariant="outlined"
                      id="FaturaTarihi"
                      size="small"
                      label={t('Fatura_Tarihi')}
                      invalidDateMessage={t('hatali_tarih')}
                      format="dd.MM.yyyy"
                      fullWidth
                      variant="outlined"
                      value={ChangeInvoiceDate}
                      disabled={readonly}
                      error={
                        ChangeType === 2 && ChangeInvoiceDate === ''
                          ? required
                          : false
                      }
                      onChange={e => handleChangeInvoiceDate(e)}
                      KeyboardButtonProps={{
                        'aria-label': 'change date'
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </ThemeProvider>
              </Grid>
              <Grid item xs={12} sm={12} lg={12}>
                <TextField
                  name="FaturaTutar"
                  label={t('Fatura_Tutari')}
                  value={ChangeInvoicePrice || 0}
                  type="text"
                  size="small"
                  onChange={handleChangeInvoicePrice}
                  fullWidth
                  variant="outlined"
                  disabled={readonly}
                />
                <p style={{ color: '#888', marginTop: '4px' }}>
                  {t('NumberFormat')}: 99,999.99
                </p>
              </Grid>
              <Grid item xs={12} sm={12} lg={12}>
                <TextField
                  label={t('Banka_Adi')}
                  name="BankaAdı"
                  multiline
                  size="small"
                  fullWidth
                  value={ChangeBankName}
                  onChange={handleChangeBankName}
                  variant="outlined"
                  disabled={readonly}
                />
              </Grid>
              <Grid item xs={12} sm={12} lg={12}>
                <TextField
                  label={t('Banka_Sube_Kodu')}
                  name="BankaKodu"
                  multiline
                  size="small"
                  fullWidth
                  value={ChangeBankCode}
                  onChange={handleChangeBankCode}
                  variant="outlined"
                  disabled={readonly}
                />
              </Grid>
              <Grid item xs={12} sm={12} lg={12}>
                <TextField
                  label={t('IBAN')}
                  name="Iban"
                  fullWidth
                  size="small"
                  value={ChangeIban}
                  onChange={handleChangeIban}
                  variant="outlined"
                  disabled={readonly}
                />
              </Grid>
              <Grid item xs={12} sm={12} lg={12}>
                <TextField
                  label={t('Vergi_Dairesi')}
                  name="Vergi Dairesi"
                  multiline
                  size="small"
                  fullWidth
                  value={ChangeTaxOffice}
                  onChange={handleChangeChangeTaxOffice}
                  variant="outlined"
                  disabled={readonly}
                />
              </Grid>
              <Grid item xs={12} sm={12} lg={12}>
                <TextField
                  label={t('Vergi_Numarasi')}
                  name="Vergi Numarası"
                  multiline
                  size="small"
                  fullWidth
                  value={ChangeTaxId}
                  onChange={handleChangeTaxId}
                  variant="outlined"
                  disabled={readonly}
                />
              </Grid>
              <Grid item xs={12} sm={12} lg={12}>
                <TextField
                  label={t('TC_Kimlik_No')}
                  name="TC Kimlik No"
                  multiline
                  size="small"
                  fullWidth
                  value={ChangeIdNumber}
                  onChange={handleChangeIdNumber}
                  variant="outlined"
                  disabled={readonly}
                />
              </Grid>
              <Grid item xs={12} sm={12} lg={12}>
                <br />
                <br />
              </Grid>
            </Grid>
          ) : (
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} lg={12}>
                {t('lblRefundTypeControl')}
              </Grid>
              <Grid item xs={12} sm={12} lg={12}>
                <br />
                <br />
              </Grid>
            </Grid>
          );
        case 3:
          return (
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} lg={12}>
                {t('lblSure')}
              </Grid>
              <Grid item xs={12} sm={12} lg={12}>
                <br />
                <br />
              </Grid>
            </Grid>
          );
        default:
          return 'Unknown stepIndex';
      }
    } else {
      switch (stepIndex) {
        case 0:
          return (
            <Grid container spacing={1}>

              { SessionUser.TenantId === 79 ?
                  (
                      <>
                        <Grid item xs={12} sm={12} lg={12}>
                          <TextField
                              size="small"
                              autoComplete="no"
                              value={ ChangeSoldTo || ''}
                              fullWidth
                              required
                              label={t('lblSoldTo')}
                              error={ChangeSoldTo === '' ? required : false}
                              variant="outlined"
                              disabled
                          />
                        </Grid>
                        <Grid item xs={9} sm={9} lg={9}>
                          <TextField
                              size="small"
                              id="consumer"
                              autoComplete="no"
                              required
                              value={ ChangeShipTo || ''}
                              fullWidth
                              label={t('lblShipTo')}
                              error={ChangeShipTo === '' ? required : false}
                              variant="outlined"
                              disabled
                          />
                        </Grid>
                        <Grid item xs={3} sm={3} lg={3}>
                          <Button
                              variant="contained"
                              style={{
                                backgroundColor: '#1E5128',
                                color: 'white'
                              }}
                              endIcon={<SearchIcon />}
                              fullWidth
                              onClick={() => setRetailerSoldToShipToPopUp(true)}
                          >
                            {t('search')}
                          </Button>
                        </Grid>
                      </>
                  ) :(<></>)
              }
              <Grid item xs={12} sm={12} lg={12}>
                <TextField
                  size="small"
                  fullWidth
                  select
                  label={t('Degisim_Nedeni')}
                  value={ChangeReason}
                  error={ChangeReason > 0 ? false : required}
                  onChange={handleChangeReason}
                  labelId="degisimNeden_label"
                  variant="outlined"
                >
                  {ChangeReasonData.map(p => {
                    return (
                      <MenuItem key={p.Id} value={p.Id}>
                        {p.MainLanguageDescription}
                      </MenuItem>
                    );
                  })}
                </TextField>
              </Grid>
              <Grid item xs={12} sm={12} lg={12} style={{ display: SessionUser.TenantId === 79 ? 'none' : 'block' }}>
                <TextField
                  size="small"
                  fullWidth
                  select
                  label={t('Degisim_Nedeni_Detay')}
                  error={ChangeReasonDetail === '' ? required : false}
                  value={ChangeReasonDetail}
                  onChange={handleChangeReasonDetail}
                  labelId="degisimNedenDetay_label"
                  variant="outlined"
                >
                  {ChangeReasonDetailData.map(p => {
                    return (
                      <MenuItem key={p.Id} value={p.Id}>
                        {p.Text}
                      </MenuItem>
                    );
                  })}
                </TextField>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                lg={12}
                style={{
                  display:
                    ChangeSparePart === 1 || ChangeDataMaterial.length > 0
                      ? 'inline'
                      : 'none'
                }}
              >
                <MaterialSearch
                  setMalzeme={setChangeMaterial}
                  setProduct={ChangeMainData[0].ModelCode}
                  value={
                    {
                      MALZEME_STOK_NO: ChangeDataMaterial.ChangeMaterialCode,
                      ACIKLAMA: ChangeDataMaterial.ChangeMaterial
                    } || ''
                  }
                  searchParam=""
                  error={
                    ChangeSparePart === 1 && UnavailableMaterial.length === 0
                      ? requiredForMaterial
                      : false
                  }
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                lg={12}
                style={{ display: ChangeSparePart === 1 ? 'inline' : 'none' }}
              >
                <TextField
                  label={t('lblMaterialOrderId')}
                  name="ExchangeMaterialOrderNr"
                  fullWidth
                  size="small"
                  value={ExchangeMaterialOrderNr}
                  onChange={handleExchangeMaterialOrderNr}
                  variant="outlined"
                />
                <List>
                  {UnavailableMaterial.map(item => (
                    <ListItem key={item.MaterialCode}>
                      <ListItemText
                        primary={item.Material}
                        secondary={item.MaterialCode}
                      />
                      <ListItemSecondaryAction>
                        <IconButton
                          edge="end"
                          style={{ color: 'red' }}
                          onClick={event =>
                            DeleteUnavailableMaterial(event, item.MaterialCode)
                          }
                          aria-label="delete"
                        >
                          <DeleteIcon />
                        </IconButton>
                      </ListItemSecondaryAction>
                    </ListItem>
                  ))}
                </List>
              </Grid>
              <Grid item xs={12} sm={12} lg={12}>
                <TextField
                  label={t('Servis_Notu')}
                  name="DegisimServisNot"
                  multiline
                  rows={3}
                  fullWidth
                  error={ChangeServiceNote === '' ? required : false}
                  value={ChangeServiceNote}
                  onChange={handleChangeServiceNote}
                  variant="outlined"
                  disabled={readonly}
                />
              </Grid>
              <Grid item xs={12} sm={12} lg={12}>
                <br />
                <br />
              </Grid>
            </Grid>
          );
        case 1:
          return (
            <Grid container spacing={1}>
              {SessionUser.TenantId === 79 || SessionUser.IsIhpTenant ? ( // USA,RUSSIA
                <Grid item xs={12} sm={12} lg={12}>
                  <TextField
                    size="small"
                    fullWidth
                    select
                    error={ChangeExchangeTypeExtend > 0 ? false : required}
                    label={t('Degisim_Turu')}
                    value={ChangeExchangeTypeExtend}
                    onChange={handleChangeExtendType}
                    labelId="degisimTur_label"
                    variant="outlined"
                  >
                    {ChangeExchangeTypeExtendData.filter(p => {
                        if (SessionUser.IsIhpTenant) {
                          const hasTP = p.SapTypeCode?.includes('TP'); //optional chaining
                            if (SessionUser.ServiceShopTypeId === 18) { //18:TradePartner
                              return hasTP;
                            } else {
                              return !hasTP;
                            }
                        }
                        return true;
                      }).map(p => {
                      return (
                        <MenuItem key={p.Id} value={p.Id}>
                          {p.Description}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                </Grid>
              ) : (
                <Grid item xs={12} sm={12} lg={12}>
                  <TextField
                    size="small"
                    fullWidth
                    select
                    error={ChangeType > 0 ? false : required}
                    label={t('Degisim_Turu')}
                    value={ChangeType}
                    onChange={handleChangeType}
                    labelId="degisimTur_label"
                    variant="outlined"
                  >
                    <MenuItem key={1} value={1}>
                      {t('ddlDegisimTur1')}
                    </MenuItem>
                    <MenuItem key={2} value={2}>
                      {t('ddlDegisimTur2')}
                    </MenuItem>
                    <MenuItem key={3} value={3}>
                      {t('ddlDegisimTur3')}
                    </MenuItem>
                  </TextField>
                </Grid>
              )}
              <Grid item xs={12} sm={12} lg={12}>
                <TextField
                  size="small"
                  fullWidth
                  select
                  label={t('lblUpgrade')}
                  value={Upgrade}
                  error={Upgrade === 0 ? required : false}
                  onChange={handleUpgrade}
                  labelId="lblUpgradeLabel"
                  variant="outlined"
                >
                  {UpgradeData?.map(item => {
                    return (
                      <MenuItem key={item.Id} value={item.Id}>
                        {item.Dsc}
                      </MenuItem>
                    );
                  })}
                </TextField>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                lg={12}
                style={{ display: Upgrade === 1 ? 'inline' : 'none' }}
              >
                <ProductSearch
                  setModel={setChangeModel}
                  error={
                    Upgrade === 1 && ChangeData.ChangeProductId === 0
                      ? required
                      : false
                  }
                  Product={ChangeMainData[0].ModelCode}
                  color="primary"
                  fullWidth
                  size="small"
                  inputVariant="outlined"
                  id="ProductCode"
                  variant="outlined"
                  value={
                    {
                      KUL_MODEL_KODU: ChangeData.ChangeProductCode,
                      ACIKLAMA: ChangeData.ChangeProduct
                    } || ''
                  }
                  searchParam=""
                  KeyboardButtonProps={{
                    'aria-label': 'change date'
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={12} lg={12}>
                <br />
                <br />
              </Grid>
            </Grid>
          );
        case 2:
          return <Grid container spacing={1}>
          {SessionUser.TenantId !== 79 ? ( // USA
            <Grid item xs={12} sm={12} lg={12}>
              <TextField
                size="small"
                fullWidth
                select
                error={ChangeGrade === 0 ? required : false}
                label={t('lblGrade')}
                value={ChangeGrade}
                onChange={handleChangeGrade}
                labelId="Grade_label"
                variant="outlined"
              >
                <MenuItem key={1} value={1}>
                  {t('lblFunctional')}
                </MenuItem>
                <MenuItem key={2} value={2}>
                  {t('lblRefurbishable')}
                </MenuItem>
                <MenuItem key={3} value={3}>
                  {t('lblScrap')}
                </MenuItem>
              </TextField>
            </Grid>
            ) : (
              <Grid item xs={12} sm={12} lg={12}></Grid>
            )}


            {SessionUser.TenantId === 79 ? ( // USA                
                <>
                  <Grid item xs={12} sm={12} lg={12}>
                    <TextField
                        size="small"
                        fullWidth
                        select
                        label={t('lblOperationSource')}
                        value={OperationSource}
                        error={OperationSource === 0 ? required : false}
                        onChange={handleOperationSource}
                        labelId="lblOperationSourceLabel"
                        variant="outlined"
                    >
                      <MenuItem key={1} value={1}>
                        {t('lblServiceShop')}
                      </MenuItem>
                      <MenuItem key={2} value={2}>
                        {t('lblDealer')}
                      </MenuItem>
                      <MenuItem key={3} value={3}>
                        {t('lblLogistics')}
                      </MenuItem>
                      <MenuItem key={4} value={4}>
                        {t('lblCallCenter')}
                      </MenuItem>           
                      <MenuItem key={5} value={5}>
                        {t('lblBuilder')}
                      </MenuItem>
                    </TextField>
                  </Grid>
                  <Grid item xs={12} sm={12} lg={12}>
                    <TextField
                        size="small"
                        fullWidth
                        select
                        label={t('lblProductLocation')}
                        value={ChangeReceived}
                        error={ChangeReceived === 0 ? required : false}
                        onChange={handleChangeReceived}
                        labelId="teslimalindi_label"
                        variant="outlined"
                    >
                      <MenuItem key={2} value={2}>
                        {t('lblCustomer')}
                      </MenuItem>
                      <MenuItem key={1} value={1}>
                        {t('lblServiceShop')}
                      </MenuItem>
                      <MenuItem key={3} value={3}>
                        {t('lblDealer')}
                      </MenuItem>             
                      <MenuItem key={4} value={4}>
                        {t('lblBuilder')}
                      </MenuItem>              
                      <MenuItem key={5} value={5}>
                        {t('lblInstaller')}
                      </MenuItem>
                    </TextField>
                  </Grid>
                </>
            ) : (
                <>
                  <Grid item xs={12} sm={12} lg={12}>
                    <TextField
                        size="small"
                        fullWidth
                        select
                        label={t('lblOperationSource')}
                        value={OperationSource}
                        error={OperationSource === 0 ? required : false}
                        onChange={handleOperationSource}
                        labelId="lblOperationSourceLabel"
                        variant="outlined"
                    >
                      <MenuItem key={1} value={1}>
                        {t('lblServiceShop')}
                      </MenuItem>
                      <MenuItem key={2} value={2}>
                        {t('lblDealer')}
                      </MenuItem>
                      <MenuItem key={3} value={3}>
                        {t('lblLogistics')}
                      </MenuItem>
                      <MenuItem key={4} value={4}>
                        {t('lblCallCenter')}
                      </MenuItem>
                    </TextField>
                  </Grid>
                  <Grid item xs={12} sm={12} lg={12}>
                    <TextField
                        size="small"
                        fullWidth
                        select
                        label={t('lblProductLocation')}
                        value={ChangeReceived}
                        error={ChangeReceived === 0 ? required : false}
                        onChange={handleChangeReceived}
                        labelId="teslimalindi_label"
                        variant="outlined"
                    >
                      <MenuItem key={2} value={2}>
                        {t('lblCustomer')}
                      </MenuItem>
                      <MenuItem key={1} value={1}>
                        {t('lblServiceShop')}
                      </MenuItem>
                      <MenuItem key={3} value={3}>
                        {t('lblDealer')}
                      </MenuItem>
                    </TextField>
                  </Grid>
                </>
            )}
            
            <Grid item xs={12} sm={12} lg={12}>
              <br />
              <br />
            </Grid>
          </Grid>;
        case 3:
          //For Russia (TenantId 118) - Show Summary instead of Fill Invoice Details
          if (SessionUser.IsIhpTenant) {
            return (
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12} lg={12}>
                  {t('lblSure')}
                </Grid>
                <Grid item xs={12} sm={12} lg={12}>
                  <br />
                  <br />
                </Grid>
              </Grid>
            );
          }
          return (
            <Grid container spacing={1}>
              {SessionUser.TenantId === 75 && (
                <Grid item xs={12} sm={12} lg={12}>
                  <TextField
                    label="EDFR #"
                    name="EDFR"
                    fullWidth
                    size="small"
                    value={EDFR}
                    onChange={handleEDFR}
                    variant="outlined"
                    disabled={readonly}
                  />
                </Grid>
              )}
              <Grid item xs={12} sm={12} lg={SessionUser.TenantId === 79 && ChangeType !== 2 ? 6 : 12}>
                <TextField
                  label={t('Fatura_No')}
                  name="FaturaNo"
                  multiline
                  fullWidth
                  size="small"
                  type="number"
                  error={(ChangeType === 2) & (ChangeInvoiceNr === '') ? required : false}
                  value={ChangeInvoiceNr}
                  onBlur={handleBlurChangeInvoiceNr}
                  onChange={handleChangeInvoiceNr}
                  variant="outlined"
                  disabled={readonly}
                />
              </Grid>
              
              { SessionUser.TenantId === 79 && ChangeType !== 2 ? (
                <>
                <Grid item xs={12} sm={12} lg={6}>
                  <TextField
                    label={t('Sales_No')}
                    name="SalesNo"
                    multiline
                    fullWidth
                    size="small"
                    error={
                      (ChangeType === 2) & (ChangeSalesNr === '')
                        ? required
                        : false
                    }
                    value={ChangeSalesNr}
                    onBlur={handleBlurChangeSalesNr}
                    onChange={handleChangeSalesNr}
                    variant="outlined"
                    disabled={readonly}
                  />
                </Grid>
                </>
              ) : (<></>)}

              { SessionUser.TenantId === 79 || SessionUser.TenantId === 69 ? (
                <>
                <Grid item xs={12} sm={12} lg={SessionUser.TenantId === 79 && ChangeType !== 2 ? 6 : 12}>
                  <TextField
                    label={t('ItemNo')}
                    name="ItemNo"
                    size="small"
                    fullWidth
                    type="number"
                    onBlur={handleBlurChangeItemNo}
                    value={ChangeItemNo}
                    onChange={handleChangeItemNo}
                    variant="outlined"
                    disabled={readonly}
                  />
                </Grid>
                </>
              ):(<></>)}

              {SessionUser.TenantId === 79 && ChangeType !== 2 ? (
                <>
                  <Grid item xs={12} sm={12} lg={6}>
                    <TextField
                      label={t('SalesItemNo')}
                      name="SalesItemNo"
                      size="small"
                      fullWidth
                      type="number"
                      onBlur={handleBlurChangeSalesItemNo}
                      value={ChangeSalesItemNo}
                      onChange={handleChangeSalesItemNo}
                      variant="outlined"
                      error = { ChangeType !== 2 && ChangeSalesItemNo === '' ? required : false}
                    />
                  </Grid>
                </>
              ) : (<></>)}

              <Grid item xs={12} sm={12} lg={SessionUser.TenantId === 79 && ChangeType !== 2 ? 6 : 12}>
                <ThemeProvider theme={materialTheme}>
                  <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                    locale={localeMap[locale]}
                  >
                    <KeyboardDatePicker
                      color="white"
                      inputVariant="outlined"
                      id="FaturaTarihi"
                      size="small"
                      label={t('Fatura_Tarihi')}
                      invalidDateMessage={t('hatali_tarih')}
                      format="dd.MM.yyyy"
                      fullWidth
                      variant="outlined"
                      value={ChangeInvoiceDate}
                      disabled={readonly}
                      error={
                        ChangeType === 2 && ChangeInvoiceDate === ''
                          ? required
                          : false
                      }
                      onChange={e => handleChangeInvoiceDate(e)}
                      KeyboardButtonProps={{
                        'aria-label': 'change date'
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </ThemeProvider>
              </Grid>

              {SessionUser.TenantId === 79 && ChangeType !== 2 ? (
                <>
                <Grid item xs={12} sm={12} lg={6}>
                  <ThemeProvider theme={materialTheme}>
                    <MuiPickersUtilsProvider
                      utils={DateFnsUtils}
                      locale={localeMap[locale]}
                    >
                      <KeyboardDatePicker
                        color="white"
                        inputVariant="outlined"
                        id="SalesDate"
                        size="small"
                        label={t('Sales_Date')}
                        invalidDateMessage={t('hatali_tarih')}
                        format="dd.MM.yyyy"
                        fullWidth
                        variant="outlined"
                        value={ChangeSalesDocDate}
                        error={
                          ChangeType === 2 && ChangeSalesDocDate === ''
                            ? required
                            : false
                        }
                        onChange={e => handleChangeSalesDocDate(e)}
                        KeyboardButtonProps={{
                          'aria-label': 'change date'
                        }}
                      />
                    </MuiPickersUtilsProvider>
                  </ThemeProvider>
                </Grid>
                </>
              ) : (<></>)}

              {SessionUser.TenantId === 79 ? (
                <>
                <Grid item xs={12} sm={12} lg={12}>
                  <TextField
                    label={t('PDI')}
                    name="PDI"
                    size="small"
                    fullWidth
                    type="number"
                    value={ChangePdi}
                    onChange={handleChangePdi}
                    variant="outlined"
                    disabled={readonly}
                  />
                </Grid>
                </>
              ) : (<></>)}
              
              <Grid item xs={12} sm={12} lg={12}>
                <TextField
                  name="FaturaTutar"
                  label={t('Fatura_Tutari')}
                  value={ChangeInvoicePrice || 0}
                  type="text"
                  size="small"
                  onChange={handleChangeInvoicePrice}
                  fullWidth
                  variant="outlined"
                  disabled={readonly}
                />
                <p style={{ color: '#888', marginTop: '4px' }}>
                  {t('NumberFormat')}: 99,999.99
                </p>
              </Grid>
              <Grid item xs={12} sm={12} lg={12}>
                <TextField
                  label={t('Banka_Adi')}
                  name="BankaAdı"
                  multiline
                  size="small"
                  fullWidth
                  value={ChangeBankName}
                  onChange={handleChangeBankName}
                  variant="outlined"
                  disabled={readonly}
                />
              </Grid>
              <Grid item xs={12} sm={12} lg={12}>
                <TextField
                  label={t('Banka_Sube_Kodu')}
                  name="BankaKodu"
                  multiline
                  size="small"
                  fullWidth
                  value={ChangeBankCode}
                  onChange={handleChangeBankCode}
                  variant="outlined"
                  disabled={readonly}
                />
              </Grid>
              <Grid item xs={12} sm={12} lg={12}>
                <TextField
                  label={t('IBAN')}
                  name="Iban"
                  fullWidth
                  size="small"
                  value={ChangeIban}
                  onChange={handleChangeIban}
                  variant="outlined"
                  disabled={readonly}
                />
              </Grid>
              <Grid item xs={12} sm={12} lg={12}>
                <TextField
                  label={t('Vergi_Dairesi')}
                  name="Vergi Dairesi"
                  multiline
                  size="small"
                  fullWidth
                  value={ChangeTaxOffice}
                  onChange={handleChangeChangeTaxOffice}
                  variant="outlined"
                  disabled={readonly}
                />
              </Grid>
              <Grid item xs={12} sm={12} lg={12}>
                <TextField
                  label={t('Vergi_Numarasi')}
                  name="Vergi Numarası"
                  multiline
                  size="small"
                  fullWidth
                  value={ChangeTaxId}
                  onChange={handleChangeTaxId}
                  variant="outlined"
                  disabled={readonly}
                />
              </Grid>
              <Grid item xs={12} sm={12} lg={12}>
                <TextField
                  label={t('TC_Kimlik_No')}
                  name="TC Kimlik No"
                  multiline
                  size="small"
                  fullWidth
                  value={ChangeIdNumber}
                  onChange={handleChangeIdNumber}
                  variant="outlined"
                  disabled={readonly}
                />
              </Grid>
              <Grid item xs={12} sm={12} lg={12}>
                <br />
                <br />
              </Grid>
            </Grid>
          );

        case 4:
          return (
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} lg={12}>
                {t('lblSure')}
              </Grid>
              <Grid item xs={12} sm={12} lg={12}>
                <br />
                <br />
              </Grid>
            </Grid>
          );
        default:
          return 'Unknown stepIndex';
      }
    }
  }



  return (
    <Page title="">
      <Card className={clsx(classes.root, className)}>
        <Snackbar open={uyari} autoHideDuration={10000} onClose={uyariKapat}>
          <Alert
            onClose={uyariKapat}
            message={responseMessage.ErrorDescription}
            variant={uyariTip}
          />
        </Snackbar>
        <Backdrop className={classes.backdrop} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <CardHeader
          style={{ textAlign: 'left' }}
          title={t('urun_Degisim')}
          subheader={ChangeMainData[0].ModelCode + ' ' + ChangeMainData[0].Model}
        />
        <Divider />
        <CardContent>
          <Stepper activeStep={activeStep} alternativeLabel>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <div>
            {activeStep === steps.length ? (
              <div>
                <Typography className={classes.instructions}>
                  {responseMessage.ErrorDescription}
                </Typography>
                <Button variant="contained" color="primary" onClick={handleReset}>{t('lblReset')}</Button>
              </div>
            ) : (
              <div>
                <Typography className={classes.instructions}>
                  {getStepContent(activeStep)}
                </Typography>
                <div>
                  <Button
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    className={classes.backButton}
                  >
                    {t('lblBack')}
                  </Button>
                  <Button variant="contained" color="primary" onClick={handleNext}
                  >
                    {activeStep === steps.length - 1 ? <b>
                      {t('lblSave')}
                    </b> : t('lblNext')}
                  </Button>
                </div>
              </div>
            )}
          </div>
        </CardContent>

      </Card>

      { SessionUser.TenantId === 79 ?
          (
              <>
                <Dialog
                    open={RetailerSoldToShipToPopUp}
                    onClose={() => setRetailerSoldToShipToPopUp(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    fullWidth
                    maxWidth="lg"
                >
                  <DialogTitle id="alert-dialog-title">
                    {t('lblRetailerSearch')}
                    <Divider />
                  </DialogTitle>
                  <DialogContent>
                    <CardContent>
                      <Grid container spacing={1}>
                        <Grid item xs={12} sm={12} lg={12}>
                          <RetailerSoldToShipToSearch
                              handleClickService={handleClickService}
                          />
                        </Grid>
                      </Grid>
                    </CardContent>
                  </DialogContent>
                  <DialogActions>
                    <Button
                        variant="contained"
                        style={{backgroundColor:'#B31312',color:'white'}}
                        size="small"
                        component="span"
                        onClick={() => setRetailerSoldToShipToPopUp(false)}
                    >
                      {t('lblClose')}
                    </Button>
                  </DialogActions>
                </Dialog>
              </>
          ):(<></>)
      }
    </Page >
  );
}

ProductChange.propTypes = {
  className: PropTypes.string
};

export default connect(
  state => ({
    tasks: state.tasks1
  }),
  { setTask }
)(ProductChange);

